import { render } from "./DashboardPage.vue?vue&type=template&id=823c3ede&scoped=true"
import script from "./DashboardPage.vue?vue&type=script&lang=js"
export * from "./DashboardPage.vue?vue&type=script&lang=js"

import "./DashboardPage.vue?vue&type=style&index=0&id=823c3ede&lang=scss&scoped=true"

import exportComponent from "/builds/apps/elevate/shepherd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-823c3ede"]])

export default __exports__